import SmallPromo from './small'
import LargePromo from './large'
import ShopPromo from './shop'
import ShirtPromo from './shirt'
import Router from './router'

export default Router
export { SmallPromo, LargePromo, ShopPromo, ShirtPromo }
